var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40234 18.0752C9.2193 19.9007 13.93 18.9973 16.7758 15.6064C20.149 11.5873 19.625 5.59563 15.6056 2.22363L12.9336 5.40742C16.0737 8.0418 16.483 12.7228 13.8478 15.8627C11.7465 18.3664 8.28692 19.2023 5.40234 18.0752Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5969 0.925113C9.77995 -0.900387 5.0693 0.00302963 2.22342 3.39392C-1.1497 7.41302 -0.625786 13.4047 3.39361 16.7767L6.06568 13.5929C2.92551 10.9585 2.51621 6.27755 5.15146 3.13761C7.25271 0.633957 10.7123 -0.201991 13.5969 0.925113Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwish);
export default __webpack_public_path__ + "static/media/swish.760c1dc0beb72800699b200aa774f832.svg";
export { ForwardRef as ReactComponent };